import type { WiringDiagramSubsectionEntity } from '../entities';

import { StsBackendOperation } from '../../sts-backend-operation';

/**
 * Parameters for fetching wiring diagram subsection/figure data for a vehicle.
 */
export type FetchWiringDiagramSubsectionsParams = {
    /** The vehicle model code (e.g. "GUE"). */
    modelCode?: string;

    /** The vehicle model year (e.g. "2024"). */
    modelYear?: string;

    /** The vehicle option/trim code (e.g. "01"). */
    optionCode?: string;

    /** Optional abort signal for cancellation. */
    signal?: AbortSignal;

    /** The Vehicle Identification Number. */
    vin?: string;
};

/**
 * Fetch wiring diagram subsection/figure data for a vehicle, used by the
 * lookup-by-electrical-grid flow to populate the diagram selector.
 */
export class FetchWiringDiagramSubsections extends StsBackendOperation {
    /**
     * Fetch wiring diagram subsections from the API and return them as domain entities.
     *
     * @param params - the vehicle identifiers, optional VIN, and optional abort signal
     * @returns the wiring diagram subsections as domain entities
     */
    async exec(params: FetchWiringDiagramSubsectionsParams): Promise<WiringDiagramSubsectionEntity[]> {
        const { signal, ...request } = params;
        const response = await this.client.fetchFailCodeWiringDiagramSubsections(request, signal);

        if (!response.success) {
            return [];
        }

        return response.data.subsectionFigures ?? [];
    }
}
